// ═══════════════════════════════════════════════════════════════════
// aemiliaQuestions.js — EVERYTHING AEMILIA CAN BE ASKED
// MASTER COPY: gamemaster/engine/aemiliaQuestions.js — vendored byte-identical
// into every title that carries her (AemiliaGuide.js reads it).
// ───────────────────────────────────────────────────────────────────
// caP'n, 2026-10-20: a Navi-type guide in every game's menu backdrop,
// "that you can ask pre made questions". Words only live here, so one
// edit answers in every game, and the Sun Dial can own this file later.
//
// THE SHAPE
//   { id, q, a, place? }
//   id    — permanent. "Seen" is remembered by id; renaming one makes it
//           show as NEW again for everyone.
//   q     — the question, as a player would ask it.
//   a     — her answer. caP'n's NPC law: say it the way a friend would,
//           as few words as it takes. Never textbook.
//   place — optional. A place id a title can OPEN (useAemiliaPlaces).
//           The "Take me there" button only shows in a game that
//           registered that id, so an Empire answer never offers a door
//           the current game doesn't have.
//
// THE PLACE IDS IN USE (add a row here when a title registers a new one)
//   name-change · skies · my-mark · crest-well · bazaar · my-hall
//
// ⚠ PRE-WRITTEN ON PURPOSE. No AI, no Firebase, no Cloudflare: asking
// her costs nothing ("does it drain?" — no).
// ═══════════════════════════════════════════════════════════════════

// The same in every game.
export const EMPIRE = [
  { id: "name", q: "How do I change my name?",
    a: "Bonnie's Bunni Basket, on the Pier. There's a Name Change at the counter. One buy and you're renamed on every Mark, in every game.",
    place: "name-change" },
  { id: "backdrops", q: "Where do I buy new backdrops?",
    a: "Backdrops live in Terror, at the Backdrop Atelier. Want a new sky over the Pier? That's Bonnie's Bunni Basket.",
    place: "skies" },
  { id: "ilk", q: "What's the H or A under my name?",
    a: "Your Ilk. H for humans, A for AI. Edit your Mark to pick what comes after the dash.",
    place: "my-mark" },
  { id: "friends", q: "How do I add a friend?",
    a: "Tap Friends in the corner and trade Mark codes. You'll be friends in every game, not just this one." },
  { id: "crests", q: "How do I swap my coins?",
    a: "The Crest Well, on the Pier. Any game's coin turns into Divine Crests there, and back out again. No fee, ever.",
    place: "crest-well" },
];

// Per title. `name` is what the middle tab says.
export const GAMES = {
  pier: {
    name: "The Pier",
    questions: [
      { id: "pier-doors", q: "How do I get into a game?",
        a: "Walk up to a building's door. Every building on the pier is a different game." },
      { id: "pier-party", q: "How do I play with a friend?",
        a: "Walk up to them and hit Party Up. Once they say yes, your leader picks a door and you all go in together." },
      { id: "pier-hall", q: "Where's my Hall?",
        a: "Your Hall of Deeds. Your trophies, your rooms, your rules.",
        place: "my-hall" },
      { id: "pier-bazaar", q: "How do I sell to other players?",
        a: "The Boardwalk Bazaar. Players sell to players there, and nobody takes a cut.",
        place: "bazaar" },
      { id: "pier-wily", q: "Who built this place?",
        a: "W'ily. Long story. Go say hi, he loves telling it." },
    ],
  },
};

// About her. Same everywhere.
export const HERSELF = [
  { id: "who", q: "Who are you?",
    a: "Aemilia. You ask, I point." },
  { id: "hide", q: "Can you get out of my way?",
    a: "Sure. Pick “Just a button” down below. On a computer you can hide me completely, and ? brings me back." },
];

export const GREETING = "Hey you. Need a hand?";
